import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=8a581342&lang=less&scoped=true"
script.__scopeId = "data-v-8a581342"

export default script